import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { AdminService } from '~admin/services/admin.service';
import { CommonService } from '~util/common.service';
import { AppUtil } from '~util/app.util';
import { Constants } from '~util/app.constant';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-listdatasource',
  templateUrl: './listdatasource.component.html',
  styleUrls: ['./listdatasource.component.css']
})
export class ListdatasourceComponent implements OnInit {

  gridApi: any;
  gridOptions: GridOptions;
  gridOptions2: GridOptions;
  columnDefs: any[]
  columnDefs2: any[]
  rowData: any[];
  rowData2: any[];
  style: {};

  constructor(private adminService: AdminService, private commonService: CommonService, private util: AppUtil) { }

  ngOnInit() {

    //List Data Sources
    this.gridOptions = this.util.getGridOptions('No data to display.');
    this.gridOptions2 = this.util.getGridOptions('Select Datasource from left grid.');
    this.columnDefs = this.getColumnDef();
    this.columnDefs2 = this.getColumnDef2();
    this.style = Constants.gridStyle;
    this.rowData = [];
    this.rowData2 = [];
    this.getRowData();
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api
  }

  getRowData() {
    this.adminService.getConciseDatasources().subscribe((data: any[]) => {
      this.rowData = data;
    });
  }

  getColumnDef() {
    return [
      { headerName: "#", valueGetter: this.getIndex, width: 50 },
      { headerName: "Datasource Name", field: "datasourceName" },
      { headerName: "Parent Search Path", field: "parentSearchPath" },
    ];
  }

  getColumnDef2() {
    return [
      { headerName: "#", valueGetter: this.getIndex, width: 50 },
      { headerName: "Connection Name", field: "connectionName" },
      { headerName: "Server Name", field: "serverName" },
      { headerName: "Database Name", field: "databaseName" }
    ];
  }

  getIndex(params) {
    return Number.parseInt(params.node.id) + 1;
  }

  exportToCSV() {
    this.gridOptions2.api.exportDataAsCsv();
  }

  onSelectionChanged(row) {
    var connections = this.gridApi.getSelectedRows()[0].connections;
    this.rowData2 = connections;

  }

  exportAll() {
    var blob = new Blob([JSON.stringify(this.rowData, null, 2)], { type: 'text/json' });
    saveAs(blob, 'Datasource_Backup.json');
  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/datasource/listdatasource/listdatasource.component.ts